export default {
  subtitle: 'Encontrá aquí las compras realizadas en este portal en los últimos 90 días:'
}
